import { Chevron } from '@/src/common/components/Chevron'
import { Modal, StyleSheet, TouchableOpacity, View, Text } from 'react-native'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'
import { GET_USER_INFO } from '@/src/common/gql/queries/user'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { parsePhoneNumber } from 'libphonenumber-js'
import { SafeAreaView } from 'react-native-safe-area-context'
import { router } from 'expo-router'
import { Section } from '@/src/common/components/Section'
import { ModalMenuScrollView } from '@/src/app/main/menu'
import { mesaColorNames } from '@/src/common/theme'

export default function PiiMenu() {
  const { data } = useLoggedInQuery(GET_USER_INFO)
  const user = data?.getUserInfo

  const phoneNumber = user?.phoneNumber
    ? parsePhoneNumber(user.phoneNumber).formatNational()
    : undefined

  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ')

  return (
    <Modal transparent visible animationType="fade">
      <SafeAreaView
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => router.dismiss()}
          style={[StyleSheet.absoluteFillObject, { flex: 1, backgroundColor: '#00000050' }]}
        />
        <ModalMenuScrollView contentContainerStyle={{ height: '100%' }}>
          <Section
            title="Account Information"
            titleStyles={{ marginLeft: 0 }}
            styleOverride={{ marginBottom: 0 }}
            style={{
              marginBottom: 0,
              width: '100%',
              minHeight: 48,
              backgroundColor: mesaColorNames['Greyscale/0 #FFFFFF'],
              paddingTop: 16,
              paddingBottom: 8,
              paddingHorizontal: 0,
            }}
            onClosePress={() => router.dismiss()}
            closeStyle={{ right: 0, position: 'absolute' }}
          />
          <Chevron
            name="Name"
            caption={fullName || 'Not provided'}
            disabled
            captionProps={{ selectable: true }}
          />
          <Chevron
            name="Phone"
            caption={phoneNumber || 'Not provided'}
            disabled
            captionProps={{ selectable: true }}
          />
          <Chevron
            name="Email"
            caption={user?.email || 'Not provided'}
            disabled
            captionProps={{ selectable: true }}
          />
          <View style={{ flexBasis: 64, flexGrow: 1 }} />
          <TouchableOpacity
            onPress={() => {
              router.dismiss()
              void openInAppBrowser(
                'https://support.mesamember.com/hc/en-us/requests/new',
                'Account Deletion',
              )
            }}
          >
            <Text
              style={{
                textAlign: 'center',
                color: mesaColorNames['semantic/fg/error #DB340B'],
                fontSize: 14,
              }}
            >
              Delete Account
            </Text>
          </TouchableOpacity>
          <View style={{ flexBasis: 32 }} />
        </ModalMenuScrollView>
      </SafeAreaView>
    </Modal>
  )
}
